var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"padding-top":"6px"}},[_vm._l((_vm.phasesArray),function(phase,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowThis(phase.PhaseName)),expression:"ShowThis(phase.PhaseName)"}],key:index,staticClass:"TimelineRow TimelineHeader",style:({
        backgroundColor: _vm.calculateBkColor(phase.Completed, phase.PhaseName),
        width: _vm.colWidth,
      })},[_c('span',[_vm._v(_vm._s(phase.PhaseName))]),_c('span',{staticClass:"fontArrow"},[_c('font-awesome-icon',{attrs:{"icon":"play"}})],1)])}),_vm._l((_vm.phasesArray),function(phase,idx){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowThis(phase.PhaseName)),expression:"ShowThis(phase.PhaseName)"}],key:("phase" + idx),staticClass:"TimelineRow TimelineDetails",style:({ width: _vm.colWidth })},_vm._l((phase.EventDetails),function(detail,d_idx){return _c('div',{key:("event" + d_idx)},[_c('div',[_c('span',{staticClass:"Rowitem"},[(detail['EventComplete?'] == 1)?_c('font-awesome-icon',{staticStyle:{"color":"lightgray"},attrs:{"icon":"check"}}):_vm._e(),(detail['EventComplete?'] == 0)?_c('font-awesome-icon',{style:({
                color: _vm.isActiveTask(
                  detail['EventComplete?'],
                  idx,
                  phase.PhaseName,
                  d_idx
                )
                  ? '#F78F2A'
                  : 'lightgray',
              }),attrs:{"icon":"circle"}}):_vm._e()],1),_c('span',{style:({
              color: _vm.calculateFontColor(
                phase.Completed,
                phase.PhaseName,
                detail['EventComplete?']
              ),
              fontWeight: _vm.isActiveTask(
                detail['EventComplete?'],
                idx,
                phase.PhaseName,
                d_idx
              )
                ? 'bold'
                : 'normal',
              cursor:
                _vm.FormatHover(detail.Event_Hover, detail['EventComplete?']) !=
                ''
                  ? 'pointer'
                  : 'default',
            }),attrs:{"title":_vm.FormatHover(detail.Event_Hover, detail['EventComplete?'])}},[_vm._v(_vm._s(detail.EventDescription))])]),(
            _vm.isActiveTask(
              detail['EventComplete?'],
              idx,
              phase.PhaseName,
              d_idx
            )
          )?_c('div',{staticStyle:{"padding-left":"28px"}},[(!_vm.isObjectEmpty(_vm.milestonesData.CurrentMilestoneNotes))?_c('span',_vm._l((_vm.milestonesData
                .CurrentMilestoneNotes[0]),function(value,propertyName,index){return _c('div',{key:index},[(propertyName != 'Alerts')?_c('div',[_vm._v(" "+_vm._s(propertyName)+": "+_vm._s(value)+" ")]):_c('div',_vm._l((value),function(alert,alertIndex){return _c('div',{key:alertIndex},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(alert.AlertDisplayFlag),expression:"alert.AlertDisplayFlag"}],staticStyle:{"padding-right":"4px"}},[_c('font-awesome-icon',{staticStyle:{"color":"#f78f2a"},attrs:{"icon":"exclamation-triangle"}})],1),_vm._v(" "+_vm._s(alert.Message)+" ")])}),0)])}),0):_vm._e()]):_vm._e()])}),0)})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }